import { __awaiter } from "tslib";
import { TeleInterconsultService } from "@/servicesTs/models/teleopi/teleInterconsult";
const moduleTableTICSent = {
    namespaced: true,
    state: {
        teleInterconsults: [],
        dataFilter: {
            step: "",
            node_id: 0,
            state: "",
        },
        showLoader: false,
    },
    getters: {
        getShowLoader(state) {
            return state.showLoader;
        },
        getTICSent(state) {
            return state.teleInterconsults;
        },
    },
    mutations: {
        setLoader(state, payLoad) {
            state.showLoader = payLoad;
        },
        setDatafilter(state, payLoad) {
            state.dataFilter = payLoad;
        },
        setTICSent(state, teleInterconsults) {
            state.teleInterconsults = teleInterconsults;
        },
    },
    actions: {
        getTICSent({ commit, state }) {
            return __awaiter(this, void 0, void 0, function* () {
                commit("setLoader", true);
                const RESPONSE = yield TeleInterconsultService.getFindByUserStepOrigin(state.dataFilter.step, state.dataFilter.node_id, state.dataFilter.state);
                commit("setTICSent", RESPONSE);
                commit("setLoader", false);
            });
        },
    },
};
export default moduleTableTICSent;
